import { Skeleton } from "@mui/material";
import {
  BlockCard,
  SegmentedPillsSkeleton,
  SelectPillSkeleton,
  TablePagerSkeleton,
} from "../primitives";
import styles from "./style.module.scss";

interface ReadingBySchoolTableSkeletonProps {
  count?: number;
  className?: string;
}

const COLUMNS = [
  "#", "School", "Status", "Band", "Reading", "vs before",
  "Regular readers", "Seats used", "Lead time", "Who to call",
];

/** Same columns, same row height and the same pager footer as the real table. */
function ReadingBySchoolTableSkeleton({
  count = 8,
  className,
}: ReadingBySchoolTableSkeletonProps) {
  return (
    <BlockCard
      flush
      title={<Skeleton variant="text" width={175} height={26} />}
      className={className}
      actions={
        <>
          <SelectPillSkeleton width={150} />
          <SegmentedPillsSkeleton count={4} width={64} />
        </>
      }
    >
      <div className={styles.scroll}>
        <table className={styles.table}>
          <thead>
            <tr>
              {COLUMNS.map((column) => (
                <th key={column} className={styles.th}>
                  {column}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: count }).map((_, index) => (
              <tr key={index} className={styles.tr}>
                <td className={styles.td}>
                  <Skeleton variant="text" width={14} height={18} />
                </td>
                <td className={`${styles.td} ${styles.schoolCell}`}>
                  <Skeleton variant="text" width={186} height={20} />
                  <Skeleton variant="text" width={132} height={16} />
                </td>
                <td className={styles.td}>
                  <Skeleton
                    variant="rounded"
                    width={64}
                    height={22}
                    sx={{ borderRadius: "16px" }}
                  />
                </td>
                <td className={styles.td}>
                  <Skeleton
                    variant="rounded"
                    width={72}
                    height={22}
                    sx={{ borderRadius: "16px" }}
                  />
                </td>
                <td className={styles.td}>
                  <Skeleton variant="text" width={72} height={20} />
                </td>
                <td className={styles.td}>
                  <Skeleton variant="text" width={52} height={20} />
                </td>
                <td className={styles.td}>
                  <Skeleton variant="text" width={64} height={20} />
                </td>
                <td className={styles.td}>
                  <Skeleton variant="text" width={62} height={20} />
                </td>
                <td className={styles.td}>
                  <Skeleton variant="text" width={56} height={20} />
                </td>
                <td className={`${styles.td} ${styles.contactCell}`}>
                  <div className={styles.contact}>
                    <Skeleton
                      variant="circular"
                      width={32}
                      height={32}
                      sx={{ flexShrink: 0 }}
                    />
                    <div className={styles.contactBody}>
                      <Skeleton variant="text" width={168} height={18} />
                      <Skeleton
                        variant="rounded"
                        width={112}
                        height={18}
                        sx={{ borderRadius: "12px", marginTop: "2px" }}
                      />
                    </div>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <TablePagerSkeleton />
    </BlockCard>
  );
}

export default ReadingBySchoolTableSkeleton;
